// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"7f6d23cf","966":"0b0abf4a"}[chunkId] + ".chunk.js";
};